import React, { useEffect, useState, useContext } from "react";
import GetBaseUrl from "../../../functions/SetBaseUrl";
import BarGraph from "../../AUD_DashboardElementsPrivate/Charts/barGraph";
import PieGraph from "../../AUD_DashboardElementsPrivate/Charts/pieGraph";
import QueryModal from "../../AUD_DashboardElementsPrivate/QueryModal";
import { GetAPISavedGraphQuery } from "../../../functions/GetAPIList";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { format } from "date-fns";
import comparisonStyles from "../../../pages/AUD_DashboardPrivate.module.scss";
import FilterNameTab from "../../../components/Atoms/FilterNameTab";

const BaseUrl = GetBaseUrl()[0];
var token = localStorage.getItem(GetBaseUrl()[1] + "_Edu_AuthToken");

const Graph = ({
  title,
  height,
  editMode,
  viewQueryResult,
  queryResult,
  index,
  reloadDashboard,
  graphType,
  HeaderFilter,
  titles,
  queryStructures,
  widgetType,
  seriesTitles,
  stacked = false,
  max = 100,
  data,
  pre = "",
  withTabs,
  fullWidthContainer,
  maxCategoryLength,
  showGraph = true,
  percentage = false,
  scroll,
  selectedFilters,
  filter1Name,
  filter2Name,
  setFilter1Name,
  setFilter2Name,
  comparisonMode,
  SelectTopBtn,
  setSelectedOptionalFilterData,
  selectedComparisonFilters,
  setActiveComparisonTab,
  comparisonTabs,
  selectedOptionalFilterData,
}) => {
  const [askQueryModal, setAskQueryModal] = useState(false);
  const [query, setQuery] = useState();
  const [maxValue, setMaxValue] = useState(max);
  const [groupByColumn, setGroupByColumn] = useState();
  const [tabIndex, setTabIndex] = useState(index[0]);
  const [subTabIndex, setSubTabIndex] = useState(0);

  const [defaultQueryStructure, setDefaultQueryStructure] = useState(
    queryStructures[0]
  );
  const [colors, setColors] = useState(["#005EFF", "#001C9A"]);
  const [allSeries, setAllSeries] = useState({
    tab1: [],
    tab2: [],
    tab3: [],
    tab4: [],
  });
  const [allCategories, setAllCategories] = useState({
    tab1: [],
    tab2: [],
    tab3: [],
    tab4: [],
  });
  const [categories, setCategories] = useState([]);
  const [series, setSeries] = useState([]);
  const [type, setType] = useState(graphType[0]);
  const [TopBtn, setTopBtn] = useState(HeaderFilter[0]);
  //-----------------------------------
  const [Filter1, setFilter1] = useState(filter1Name && filter1Name);
  const [Filter2, setFilter2] = useState(filter2Name && filter2Name);

  useEffect(() => {
    setFilter1(filter1Name);
  }, [filter1Name]);

  useEffect(() => {
    setFilter2(filter2Name);
  }, [filter2Name]);
  //----------------------------------------------------

  const [tabs, setTabs] = useState([
    {
      index: index[0],
      title: titles[0],
      width: "25%",
      active: true,
      categories: allCategories.tab1,
      series: allSeries.tab1,
      hasError: false,
      type: graphType[0],
      topBtns: HeaderFilter[0],
    },
    {
      index: index[1],
      title: titles[1],
      width: "25%",
      active: false,
      categories: allCategories.tab2,
      series: allSeries.tab2,
      hasError: false,
      type: graphType[1],
      topBtns: HeaderFilter[1],
    },
    {
      index: index[2],
      title: titles[2],
      width: "25%",
      active: false,
      categories: allCategories.tab3,
      series: allSeries.tab3,
      hasError: false,
      type: graphType[2],
      topBtns: HeaderFilter[2],
    },
  ]);
  //---------------------------------------------------
  const getObjByIndex = (array, i) => {
    const item = array.find((element) => element.title === i);
    return item ? item : "noObject";
  };
  //---------------------------------------------------
  function setActiveTab(arr, Value) {
    if (tabIndex !== getObjByIndex(arr, Value).index) {
      const array = [...arr];
      for (var i = 0; i < array.length; i++) {
        array[i]["active"] = false;
      }
      let a;
      for (var i = 0; i < array.length; i++) {
        if (array[i].title === Value) {
          array[i].active = true;
          setCategories(array[i].categories);
          setSeries(array[i].series);
          setTabIndex(index[i]);
          a = i;
          break;
        }
      }

      setDefaultQueryStructure(queryStructures[a]);
      setTabs(array);
      setType(getObjByIndex(arr, Value).type);
      setTopBtn(getObjByIndex(arr, Value).topBtns);
    }
  }
  //----------------------------------------------------
  const handleSave = (queryId = tabIndex, wt = "") => {
    let Query = {
      queryId: queryId,
      queryType: "report",
      widgetType: wt ? wt : widgetType[index.indexOf(queryId)],
      queryName: query.queryName,
      queryText: query.query,
      reportId: query.reportId,
      tableId: "00000000-0000-0000-0000-000000000000",
      columnId: "00000000-0000-0000-0000-000000000000",
      platformName: "AUD",
    };
    if (query.queryName && query.query && query.reportId) {
      axios
        .post(BaseUrl + "/Report/InsertReportQuery", Query, {
          headers: {
            Authorization: `Bearer ${token}`,
            "content-type": "application/json",
          },
        })
        .then((res) => {
          toast.success("Query has been added", {
            position: toast.POSITION.TOP_RIGHT,
          });
          viewQueryResult([queryId], selectedFilters);
        })
        .catch((res) => {
          toast.error(res + "", {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .finally(() => {});
      return true;
    } else {
      toast.warning("Enter required values", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
  };
  //----------------------------------------------

  const [selectedInternalFilters, setSelectedInternalFilters] = useState();

  const isArrayofJSONObjects = (variable) => {
    if (!Array.isArray(variable)) {
      return false;
    }

    return variable.every(
      (item) =>
        typeof item === "object" && item !== null && !Array.isArray(item)
    );
  };
  //----------------------------------------------

  useEffect(() => {
    // console.log(comparisonTabs);

    comparisonTabs &&
      comparisonTabs.map((item) => {
        item.active &&
          item.index &&
          setSelectedInternalFilters(selectedComparisonFilters);
      });
  }, [selectedComparisonFilters]);

  useEffect(() => {
    // console.log("1- selectedFilters in graph query");

    comparisonMode
      ? setSelectedInternalFilters(selectedFilters)
      : viewQueryResult([tabIndex], selectedFilters);
  }, [selectedFilters]);

  ///**********************
  useEffect(() => {
    // console.log("2- selectedInternalFilters in graph query");

    selectedInternalFilters &&
      viewQueryResult([tabIndex], selectedInternalFilters);
  }, [selectedInternalFilters]);
  ///**********************
  useEffect(() => {
    // console.log("3- selectedOptionalFilterData in graph query");

    selectedOptionalFilterData &&
      selectedOptionalFilterData.length &&
      viewQueryResult(
        [selectedOptionalFilterData[0] && selectedOptionalFilterData[0].graph],
        comparisonMode ? selectedInternalFilters : selectedFilters
      );
  }, [selectedOptionalFilterData]);
  //----------------------------------------------

  useEffect(() => {
    if (data[0] && data[0].content && !data[0].content.length) {
      setSeries([]);
      setCategories([]);
    } else {
      for (let i = 0; i < data.length; i++) {
        const queryResult = data[i];

        if (queryResult && queryResult.queryId !== tabIndex) {
          continue;
        }

        if (
          queryResult &&
          queryResult.queryId === tabIndex &&
          !queryResult.content.length
        ) {
          setSeries([]);
          setCategories([]);
        } else if (
          queryResult &&
          queryResult.queryId === tabIndex &&
          queryResult.content.length
        ) {
          let result = queryResult.content;
          if (result !== "no" && isArrayofJSONObjects(result)) {
            let cat = [];
            for (let j = 0; j < result.length; j++) {
              const element = result[j];

              element["xAxis"] &&
                cat.push(
                  widgetType[index.indexOf(tabIndex)] !== "LineDateGraph"
                    ? `${pre}${element["xAxis"]}`
                    : format(new Date(element["xAxis"]), "MMMM dd") //MMMM dd, yyyy
                );
            }

            let arrayOfSeries = [];
            for (let j = 0; j < seriesTitles.length; j++) {
              const eachTitle = seriesTitles[j];
              let ser = [];
              for (let i = 0; i < result.length; i++) {
                const element = result[i];
                // console.log(element.yAxis);

                if (percentage) {
                  element["xAxis"] &&
                    element &&
                    element.zAxis &&
                    ser.push(element["zAxis"][j]);
                } else {
                  element["xAxis"] &&
                    element &&
                    element.yAxis &&
                    ser.push(element["yAxis"][j]);
                }
              }
              arrayOfSeries.push({
                name: eachTitle,
                data: ser,
              });
            }

            setSeries(arrayOfSeries);
            setCategories(cat);
          }

          break;
        }
      }
    }
  }, [data]);

  //---------------------------------------------------
  useEffect(() => {
    viewQueryResult(
      [query && query.queryId],
      comparisonMode ? selectedInternalFilters : selectedFilters
    );
  }, [query]);
  //---------------------------------------------------
  useEffect(() => {
    setSelectedOptionalFilterData([]);
    tabIndex === 22 && setColors(["#2463EB", "#FAA3AE"]);
    tabIndex === 23 && setColors(["#17C0EB", "#001C9A"]);
    const SavedGraphQuery = async () => {
      try {
        const data = await GetAPISavedGraphQuery("AUD");

        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          // console.log(tabIndex);
          if (element.queryId !== tabIndex) {
            continue;
          }
          if (element.queryId === tabIndex) {
            setQuery({
              queryName: element.queryName,
              reportId: element.reportId,
              query: element.queryText,
              queryId: element.queryId,
            });
            setGroupByColumn(element.groupByColumn && element.groupByColumn);
            break;
          }
        }
      } catch (error) {
        console.error("Error :", error);
      }
    };
    SavedGraphQuery();
  }, [tabIndex]);

  //---------------------------------------------------
  useEffect(() => {
    setSelectedOptionalFilterData([]);

    const SavedGraphQuery = async () => {
      try {
        const data = await GetAPISavedGraphQuery("AUD");

        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          if (element.queryId !== subTabIndex) {
            continue;
          }
          if (element.queryId === subTabIndex) {
            setQuery({
              queryName: element.queryName,
              reportId: element.reportId,
              query: element.queryText,
              queryId: element.queryId,
            });
            break;
          }
        }
      } catch (error) {
        console.error("Error :", error);
      }
    };
    SavedGraphQuery();
  }, [subTabIndex]);

  //---------------------
  useEffect(() => {
    !comparisonMode && viewQueryResult([tabIndex], selectedFilters);

    !comparisonMode &&
      setActiveComparisonTab(comparisonTabs, comparisonTabs[0].title);
  }, [comparisonMode]);
  //---------------------------------------------------

  return (
    <div className={`${comparisonStyles.FullyContainer}`}>
      {comparisonTabs && comparisonMode && (
        <div className={`${comparisonStyles.comparisonTabsContainer} row`}>
          {comparisonTabs.map((tab, i) => {
            return (
              <div
                key={tab.title}
                className={`${comparisonStyles.tab} ${
                  tab.active ? comparisonStyles.active : ""
                } `}
                style={{ width: tab.width }}
                onClick={() =>
                  setActiveComparisonTab(comparisonTabs, tab.title)
                }
              >
                <FilterNameTab
                  filter={!i && Filter1 ? Filter1 : i && Filter2 ? Filter2 : ""}
                  filterType={
                    !i && Filter1 ? "normal" : i && Filter2 ? "comparison" : ""
                  }
                  setFilter1Name={setFilter1}
                  setFilter2Name={setFilter2}
                  setSelectedInternalFilters={setSelectedInternalFilters}
                />
              </div>
            );
          })}
        </div>
      )}

      {showGraph && (
        <BarGraph
          setSubTabIndex={setSubTabIndex}
          subTabIndex={subTabIndex}
          setTabIndex={setTabIndex}
          programBarGraph={false}
          groupByColumn={groupByColumn}
          selectedFilters={selectedFilters}
          maxCategoryLength={maxCategoryLength}
          withQuery={editMode}
          setAskQueryModal={setAskQueryModal}
          height={height}
          title={title}
          Gtype={type ?? graphType}
          TopBtn={TopBtn}
          SelectTopBtn={SelectTopBtn}
          tabs={withTabs && tabs}
          comparisonTabs={comparisonMode && comparisonTabs}
          showtoolbar={false}
          colors={colors}
          series={series}
          categories={categories}
          handleSave={handleSave}
          setActiveTab={setActiveTab}
          tabIndex={tabIndex}
          stacked={stacked}
          max={maxValue}
          pre={pre}
          queryStructures={queryStructures}
          fullWidthContainer={fullWidthContainer}
          percentage={percentage}
          scroll={scroll}
          filter1Name={filter1Name}
          filter2Name={filter2Name}
          setFilter1Name={setFilter1Name}
          setFilter2Name={setFilter2Name}
          comparisonMode={comparisonMode}
          setSelectedInternalFilters={setSelectedInternalFilters}
        />
      )}

      {askQueryModal ? (
        <QueryModal
          setSubTabIndex={setSubTabIndex}
          subTabIndex={subTabIndex}
          setAskQueryModal={setAskQueryModal}
          query={query}
          setQuery={setQuery}
          handleSave={handleSave}
          setCategories={setCategories}
          setSeries={setSeries}
          categories={categories}
          series={series}
          defaultQueryStructure={defaultQueryStructure}
        />
      ) : null}
    </div>
  );
};

export default Graph;
